
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom'

export default function NavbarMio({ ruta }) {
    let clase1 = ruta === 'admin' ? 'text-decoration-underline fw-bold' : ''
    let clase2 = ruta === 'solicitudes_salida' ? 'text-decoration-underline fw-bold' : ''
    let clase3 = ruta === 'archivos' ? 'text-decoration-underline fw-bold' : ''
    let clase4 = ruta === 'comision' ? 'text-decoration-underline fw-bold' : ''
    let clase5 = ruta === 'vacaciones' ? 'text-decoration-underline fw-bold' : ''
    let clase6 = ruta === 'notificaciones' ? 'text-decoration-underline fw-bold' : ''


    const salir = () => {
        if ( !window.confirm('¿Estas seguro de querer cerrar sesión?') ) return

        localStorage.removeItem('user_empleado')
        window.location.href = '/'
    }

    return (
        <Navbar bg="light" data-bs-theme="light">
            <Container>
                <Nav className="w-100 d-flex flex-wrap justify-content-between">

                    {/* botones de la derecha */}
                    <div className='d-flex flex-wrap'>
                        <Link to='/admin' className={`nav-link ${clase1}`}>
                            Empleados
                        </Link>
                        <Link to='/admin/solicitudes_salida' className={"nav-link " + clase2}>
                            Salidas
                        </Link>
                        <Link to='/admin/archivos' className={"nav-link " + clase3}>
                            Archivos
                        </Link>
                        <Link to='/admin/comision' className={"nav-link " + clase4}>
                            Comisión
                        </Link>
                        <Link to='/admin/vacaciones' className={"nav-link " + clase5}>
                            Vacaciones
                        </Link>
                        <Link to='/admin/notificaciones' className={"nav-link " + clase6}>
                            Notificaciones
                        </Link>
                    </div>

                    {/* botones de la izquierda */}
                    <div>
                        <Link to='#' className={"nav-link"} onClick={ salir }>
                            Salir
                        </Link>
                    </div>
                </Nav>
            </Container>
        </Navbar>
    )
}
